//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import defaultPage from '@/components/common/defaultPage';
import draggable from 'vuedraggable';
import oaDialog from '@/components/form-common/dialog-form';
import { crudSeniorSaveApi, crudSeniorDelApi, crudSeniorSortApi } from '@/api/develop';
export default {
  name: '',
  components: {
    oaDialog: oaDialog,
    draggable: draggable,
    defaultPage: defaultPage
  },
  props: {
    keyName: {
      type: String,
      default: ''
    },
    view_search_boolean: {
      type: Number,
      default: 0
    },
    senior_search: {
      type: Array,
      default: []
    },
    list: {
      type: Array,
      default: []
    }
  },
  data: function data() {
    return {
      show: false,
      fromData: {
        width: '500px',
        title: '新建视图',
        btnText: '确定',
        labelWidth: '100px',
        type: ''
      },
      formDataInit: {
        senior_title: '',
        senior_type: '0'
      },
      formConfig: [{
        type: 'input',
        label: '视图名称：',
        placeholder: '请输入视图名称(10个字以内)',
        key: 'senior_title'
      }, {
        type: 'radio',
        label: '视图类型：',
        placeholder: '请选择视图类型',
        key: 'senior_type',
        options: [{
          value: '个人',
          label: '0'
        }, {
          value: '公共',
          label: '1'
        }]
      }],
      formRules: {
        senior_title: [{
          required: true,
          message: '请输入视图名称',
          trigger: 'blur'
        }, {
          min: 0,
          max: 10,
          message: '最多输入10个字',
          trigger: 'blur'
        }],
        senior_type: [{
          required: true,
          message: '请选择视图类型',
          trigger: 'change'
        }]
      },
      where: {
        title: ''
      }
    };
  },
  mounted: function mounted() {},
  methods: {
    handleClose: function handleClose() {
      this.show = false;
    },
    addViewFn: function addViewFn() {
      this.formDataInit = {
        senior_title: '',
        senior_type: '0'
      };
      this.fromData.title = '新建视图';
      this.$refs.oaDialog.openBox();
    },
    delFn: function delFn(item) {
      var _this = this;
      this.$modalSure('确定删除此数据').then(function () {
        crudSeniorDelApi(_this.keyName, item.id).then(function (res) {
          if (res.status == 200) {
            _this.$emit('getViewList');
          }
        });
      });
    },
    editFn: function editFn(item) {
      this.formDataInit = {
        senior_title: item.senior_title,
        senior_type: item.senior_type + '',
        id: item.id,
        search_boolean: item.view_search_boolean,
        senior_search: item.senior_search
      };
      this.fromData.title = '编辑视图';
      this.$refs.oaDialog.openBox();
    },
    onStart: function onStart() {},
    onEnd: function onEnd() {
      var _this2 = this;
      var obj = {
        id: []
      };
      this.list.map(function (item) {
        obj.id.push(item.id);
      });
      crudSeniorSortApi(this.keyName, obj).then(function (res) {
        _this2.$emit('getViewList');
      });
    },
    changeList: function changeList() {
      this.$emit('getViewList', this.where.title);
    },
    submit: function submit(data) {
      var _this3 = this;
      data.sort = 0;
      if (!data.id) {
        data.search_boolean = this.view_search_boolean;
        data.senior_search = this.senior_search;
      }
      data.search_boolean = this.view_search_boolean;
      data.senior_search = this.senior_search;
      if (data.senior_type == 2) {
        data.senior_type = 0;
      }
      crudSeniorSaveApi(this.keyName, data).then(function (res) {
        if (res.status == 200) {
          _this3.$emit('getViewList');
          _this3.$refs.oaDialog.handleClose();
        }
      });
    },
    openBox: function openBox() {
      this.show = true;
    }
  }
};